interface IQuestion {
    question: string;
    answerOptions: string[];
}

export const questions: IQuestion[] = [
    {
        question: "The lowest credit score you can get is 100.",
        answerOptions: ["True", "False"]
    },
    {
        question: "Which of the following is NOT included in a credit report?",
        answerOptions: ["Middle Names", "Current Employment Status", "Credit Score", "Public Records (e.g. bankruptcies)"]
    },
    {
        question: "Checking your own credit report will lower your credit score.",
        answerOptions: ["True", "False"]
    },
    {
        question: "You have a credit card with a $5,000 limit and a $1,000 balance. What is your current utilization ratio?",
        answerOptions: ["5%", "20%", "80%", "100%"]
    },
    {
        question: "Which action is most likely to help improve your credit score over time?",
        answerOptions: ["Opening 1 new credit account yearly", "Making on-time payments consistently", "Always close your oldest credit card", "Try to get the highest limit credit card you can afford"]
    },
    {
        question: "A hard inquiry from applying for new credit will lower your credit score.",
        answerOptions: ["True", "False"]
    },
    {
        question: "Which factor typically has the largest impact on your credit score?",
        answerOptions: ["Length of credit history", "Payment history", "Types of credit (e.g., revolving vs installment)", "New credit inquiries"]
    },
    {
        question: '"Disputing" or “credit counseling” services can remove negative items from your credit report.',
        answerOptions: ["True", "False"]
    },
    {
        question: 'If you miss a single payment by one month, it does not typically affect your credit report?',
        answerOptions: ["True", "False"]
    },
    {
        question: 'Which of the following is a good practice to maintain healthy credit?',
        answerOptions: ["Only paying minimum payments", "Setting up automatic payments to avoid late payments", "Closing all unused accounts immediately", "Ignoring your credit report until you want a loan"]
    },
];

export const answers: string[] = [
    'B',
    'B',
    'B',
    'B',
    'B',
    'A',
    'B',
    'B',
    'B',
    'B',
];

export const checkAnswers = (submission: Record<any, any>) => {
    const keys = Object.keys(submission);
    
    let correctCounter: number = 0;
    const incorrect = {
        q1: '',
        q2: '',
        q3: '',
        q4: '',
        q5: '',
        q6: '',
        q7: '',
        q8: '',
        q9: '',
        q10: '',
    };

    for(let i = 0; i < keys.length; i++) {
        const key = keys[i]
        //@ts-ignore
        const currentAnswer = submission[key];
        const correctAnswer = answers[i];

        console.log({currentAnswer, correctAnswer});
        if(currentAnswer === correctAnswer) correctCounter++;
        //@ts-ignore
        else incorrect[`q${i+1}`] = "Incorrect Please Try Again"
    }

    return { pass: correctCounter === 10, incorrect }
}